import fetch,{postFrom} from '../utils/fetch';


export function getLogList(params) {
  return fetch({
    method: 'GET',
    url: 'log/getLogList',
    params
  })
}

export function getBaseHistoryList(params) {
  return fetch({
    method: 'GET',
    url: 'log/getBaseUpdateHistory',
    params
  })
}
